import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getScheduleTree } from '@sportninja/common/services/competition/getScheduleTree'
import { buildOperationsTree } from '@sportninja/common/features/competition/operations/utils/buildOperationsTree'
import type { OperationsNode } from '@sportninja/common/features/competition/operations/types/operations.types'

/** Re-selecting a recently viewed node stays instant without going stale. */
export const OPERATIONS_STALE_TIME = 30_000

/**
 * Loads the whole competition hierarchy in one request. Every column the rail
 * and the grids render comes from this payload, so selecting a division or a
 * season costs no further calls.
 */
export const useOperationsTree = (scheduleId: string) => {
  'use memo'

  const query = useQuery({
    queryKey: queryKeys.operations.tree(scheduleId),
    queryFn: () => getScheduleTree(scheduleId),
    enabled: Boolean(scheduleId),
    staleTime: OPERATIONS_STALE_TIME,
  })

  const nodes: OperationsNode[] = buildOperationsTree(query.data)

  return {
    nodes,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  }
}
